module.exports = [
    {
        sku: 'Omni-D',
        details:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        quantity: 1,
        unit: 'year',
        purchaseDate: new Date(2016, 11, 1, 0, 0, 0, 0)
    },
    {
        sku: 'LDMS',
        details: 'LDMS details',
        quantity: 1,
        unit: '',
        purchaseDate: new Date(2014, 11, 1, 0, 0, 0, 0)
    },
    {
        sku: 'LDMS-CAL',
        details: 'LDMS-CAL details',
        quantity: 50,
        unit: '',
        purchaseDate: new Date(2015, 1, 1, 0, 0, 0, 0)
    }
];



// WEBPACK FOOTER //
// ./modules/license/services/licenseOverviewService.purchasesHistory.mock.js